// Plik: js/iusac-mobile-filters.js

document.addEventListener('DOMContentLoaded', function () {
  // Znajdź potrzebne elementy na stronie
  const toggleBtn = document.querySelector('.iusac-filters-toggle-btn');
  const closeBtn = document.querySelector('.iusac-filters-close-btn');
  const filtersWrapper = document.querySelector('.iusac-filters-wrapper');
  const body = document.body;

  // Sprawdź, czy wszystkie elementy istnieją, aby uniknąć błędów
  if (!toggleBtn || !closeBtn || !filtersWrapper) {
    // Jeśli na stronie nie ma filtrów, zakończ działanie skryptu
    return;
  }

  // Funkcja otwierająca panel filtrów
  const openFilters = () => {
    filtersWrapper.classList.add('is-open');
    // Dodajemy klasę do body, aby zablokować przewijanie tła
    body.classList.add('filters-panel-open');

    // WCAG 2.1: Oznaczenie panelu jako widocznego dla czytników ekranu
    filtersWrapper.setAttribute('aria-hidden', 'false');

    // WCAG 2.1: Przeniesienie fokusu do panelu
    const firstFocusable = filtersWrapper.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      firstFocusable.focus();
    }

    // WCAG 2.1: Aktualizacja stanu przycisku otwierającego
    toggleBtn.setAttribute('aria-expanded', 'true');
  };

  // Funkcja zamykająca panel filtrów
  const closeFilters = () => {
    filtersWrapper.classList.remove('is-open');
    // Usuwamy klasę blokującą przewijanie
    body.classList.remove('filters-panel-open');

    // WCAG 2.1: Oznaczenie panelu jako ukrytego dla czytników ekranu
    filtersWrapper.setAttribute('aria-hidden', 'true');

    // WCAG 2.1: Przywrócenie fokusu do przycisku otwierającego
    toggleBtn.focus();

    // WCAG 2.1: Aktualizacja stanu przycisku
    toggleBtn.setAttribute('aria-expanded', 'false');
  };

  // Nasłuchuj kliknięcia na przycisk otwierający
  toggleBtn.addEventListener('click', openFilters);

  // Nasłuchuj kliknięcia na przycisk zamykający
  closeBtn.addEventListener('click', closeFilters);

  // WCAG 2.1: Obsługa klawisza Escape do zamykania panelu
  filtersWrapper.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filtersWrapper.classList.contains('is-open')) {
      closeFilters();
    }
  });

  // WCAG 2.1: Inicjalizacja atrybutów ARIA
  filtersWrapper.setAttribute('aria-hidden', 'true');
  filtersWrapper.setAttribute('role', 'dialog');
  filtersWrapper.setAttribute('aria-modal', 'true');
  filtersWrapper.setAttribute('aria-label', 'Panel filtrów pojazdów');
  toggleBtn.setAttribute('aria-expanded', 'false');
  toggleBtn.setAttribute('aria-controls', 'iusac-filters-panel');

  // Dodanie ID do panelu dla aria-controls
  if (!filtersWrapper.id) {
    filtersWrapper.id = 'iusac-filters-panel';
  }

  // WCAG 2.1: Pułapka fokusu w panelu (focus trap)
  const trapFocus = (e) => {
    if (!filtersWrapper.classList.contains('is-open')) return;

    const focusableElements = filtersWrapper.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    // Jeśli Tab jest wciśnięty bez Shift i jesteśmy na ostatnim elemencie
    if (!e.shiftKey && e.key === 'Tab' && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }

    // Jeśli Shift+Tab jest wciśnięty i jesteśmy na pierwszym elemencie
    if (e.shiftKey && e.key === 'Tab' && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    }
  };

  document.addEventListener('keydown', trapFocus);
});
